<template>
	<div class="v-application">
		<headerNav @handleBrage="handleBrage"></headerNav>
		<div class="v-application-wrapper">
			<div class="v-application-container">
				<sideBar ref="sideBarRef" :menuUrl="'live-lists'"></sideBar>
				<div class="v-content-white-wrapper">
					<div class="table-container">
						<div class="card-header">
							<h1 class="fs-20">Apply for live streaming</h1>
							<el-button size="mini" @click="iframeBack">Back</el-button>
						</div>
						<div class="form-container" id="scrollToElement">
							<el-form ref="ruleForm" label-position="left" :model="form" :rules="rules" label-width="100%">
								<el-form-item label="Room Name:" prop="name">
									<el-input v-model="form.name" style="max-width: 350px;"></el-input>
								</el-form-item>
								<el-form-item label="Introduction:" prop="title">
									<el-input v-model="form.title" style="max-width: 350px;"></el-input>
								</el-form-item>
								<el-form-item label="Digital human:" prop="robotId">
									<div class="v-upload-container">
										<div class="v-upload-area" :class="form.robotId == item.robotId ? 'v-upload-area-selected' : ''" style="position: relative;" v-for="item in robotList" @click="selectRobot(item)">
											<img :src="item.robotImg"  class="uploaded-img" />
											<div class="upload-placeholder">{{item.robotName}}</div>
										</div>
									</div>
								</el-form-item>
								<el-form-item label="Product:" prop="product">
									<div class="product-card-wrapper">
										<div class="all-wrapper">
											<div class="search-container">
												<div class="search-product-inner">
													<div class="search-block">
														<el-input v-model="queryParams.productName" placeholder="Product Name"
															clearable></el-input>
													</div>
												</div>
												<div class="search-btns" style="margin-top: 5px;">
													<el-button type="primary" size="small" @click="getList">
														Search
													</el-button>
													<el-button size="small" @click="reset">Reset
													</el-button>
												</div>
											</div>
											<div class="table-wrap product-card-table">
												<el-table ref="multipleTable" :data="tableData" style="width: 100%"
													@selection-change="handleSelectionChange"  :row-class-name="tableRowClassName">
												    <el-table-column type="selection" width="42" :selectable="checkSelectable"></el-table-column>
													<el-table-column prop="name" label="Icon" width="100">
														<template v-slot="scope">
															<el-image style="width: 80px; height: 80px" :src="scope.row.icon">
															</el-image>
														</template>
													</el-table-column>
													<el-table-column prop="productName" label="Name"></el-table-column>
													<el-table-column prop="discountPrice" label="Price" width="100">
													</el-table-column>
												</el-table>
											</div>
											<div class="page-contrainer d-flex">
												<el-pagination :page-count="isMobile ? 4 : 10" background layout="prev, pager, next" :total="total"
													:current-page.sync="queryParams.pageNum" @current-change="getList">
												</el-pagination>
											</div>
										</div>
									
										<div class="card-option-block">
											<!-- <el-button type="primary" @click="addStoreProduct">Add<i
													class="el-icon-arrow-right el-icon--right"></i></el-button> -->
										</div>
										<div class="select-wrapper">
											<div class="search-container">
												<div class="search-btns">
													<!--										<el-button type="primary" @click="deleteStoreProduct" size="small">{{ $t('button.delete') }}</el-button>-->
												</div>
											</div>
											<div class="table-wrap product-card-table">
												<el-table ref="delMultipleTable" :data="storeProductList" style="width: 100%"
													@selection-change="deleteSelectionChange">
													<el-table-column type="selection" width="42"></el-table-column>
													<el-table-column prop="productName" label="Name"></el-table-column>
													<el-table-column prop="discountPrice" label="Price" width="80">
													</el-table-column>
												</el-table>
											</div>
										</div>
									</div>
								</el-form-item>
								<el-form-item>
								    <el-button type="primary" @click="submitForm()">Save</el-button>
								    <el-button @click="resetForm()">Reset</el-button>
								</el-form-item>
								
							</el-form>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import headerNav from '../../components/headerNativation.vue'
	import sideBar from '../../components/sideBar.vue'
	import tabBar from '../../components/tabBar.vue'
	import empty from '../../components/empty.vue'
	import { getProductList,getRobotList,applyRoom } from "@/api/live";
	import {selectStoreProduct,queryTypelist} from "@/api/storeProduct";

	export default {
		components: {
			headerNav,
			sideBar,
			tabBar,
			empty
		},
		data() {
			return {
				isMobile: false,
				form: {
					name: '',
					product: '',
					robotId:'',
					title:''
				},
				rules: {
				    name: [
				        { required: true, message: 'Please enter the live broadcast name', trigger: 'change' }
				    ],
					title: [
					    { required: true, message: 'Please enter the description of the live streaming room', trigger: 'change' }
					],
					robotId: [
					    { required: true, message: 'Please select the digital human', trigger: 'change' }
					],
				},
				pageNo: 20,
				queryParams: {
					pageNum: 1,
					pageSize: 10,
					productName: null,
				},
				categoryOptions: [
				
				],
				queryStoreProduct: {
					pageNum: 1,
					pageSize: 10,
					productName: null
				},
				// 总条数
				total: 0,
				tableData: [],
				storeProductList: [],
				multipleSelection: [],
				// 删除选中项
				deleteSelection: [],
				robotList:[]
			}
		},
		created() {
			this.isMobile = this.webIsMobile()
			this.getList();
			this.selectTypelist();
			this.getRobot()
		},
		methods: {
			handleBrage(){
				this.$refs.sideBarRef.handleBrage()
			},
			submitForm() {
			    this.$refs.ruleForm.validate((valid) => {
			        if (valid) {
						if (this.multipleSelection.length == 0) {
							this.$message.warning('Please select at least one item');
							return false;
						}
						var productIds = ''
						this.multipleSelection.forEach(item => {
							productIds += item.storeProductNo + ',';
						});
						if(productIds){
							productIds = productIds.substring(0, productIds.length - 1);
						}
						var that = this
						var params = {
							roomName:this.form.name,
							title:this.form.title,
							robotId:this.form.robotId,
							productIds:productIds
						}
						applyRoom(params).then(res => {
							if (res.code == 200) {
								this.$message.success('Submission successful!');
								setTimeout(() => {
									that.openPage('live-lists')
								}, 1000)
							}else{
								this.$message.error('Submission failed!');
							}
						});
			        } else {
						const element = document.getElementById('scrollToElement');
						element.scrollIntoView({ behavior: 'smooth' });
			        }
			    });
			},
			resetForm() {
			    this.$refs.ruleForm.resetFields();
				this.multipleSelection = []
				this.storeProductList = []
				this.getList();
				const element = document.getElementById('scrollToElement');
				element.scrollIntoView({ behavior: 'smooth' });
			},
			selectTypelist() {
				queryTypelist().then(res => {
					if (res.code == 200) {
						this.categoryOptions = res.data;
					}
				})
			},
			handleCategoryChange(value) {
				// value 是数组，例如 ['epidemic', 'medical-masks']
				if (value && value.length === 2) {
					this.queryParams.category = value[1]; // 使用二级分类值作为过滤条件
					this.getList(); // 自动触发搜索
				} else {
					this.queryParams.category = null;
				}
			},
			deleteStoreProduct() {
				if (this.deleteSelection.length == 0) {
					this.$message.warning('Please select at least one item');
					return false;
				}
				deleteStoreProduct(this.deleteSelection).then(res => {
					if (res.code == 200) {
						this.$message({
							message: 'Delete Success',
							type: 'success'
						});
						this.getList();
					} else {
						return false;
					}
				})
			},
			addStoreProduct() {
				if (this.multipleSelection.length == 0) {
					this.$message.warning('Please select at least one item');
					return false;
				}
				addStoreProduct(this.multipleSelection).then(res => {
					if (res.code == 200) {
						this.$message({
							message: 'Add Success',
							type: 'success'
						});
						this.getList();
					} else {
						this.$message({
							message: res.msg,
							type: 'error'
						});
						return false;
					}
				})
			},
			reset() {
				this.queryParams = {
					pageNum: 1,
					pageSize: 10,
					productName: null
				}
				this.getList();
			},
			getList() {
				const params = {
					...this.queryParams
				};
				selectStoreProduct(params).then(res => {
					if (res.code == 200) {
						this.tableData = res.rows;
						this.total = res.total;
						// Add the row selection logic here
						this.$nextTick(() => {
							this.tableData.forEach(row => {
								// if (row.cksta === 1) {
								//   this.$refs.multipleTable.toggleRowSelection(row, true);
								// }
							});
						});
					} else {
						this.$message.error(res.msg || 'Failed to load products');
					}
				});
			},
			checkSelectable(row, index) {
				return row.cksta !== 1;
			},
			tableRowClassName({ row, rowIndex}) {
				if (row.cksta === 1) {
					return 'is-disabled';
				}
				return '';
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
				this.storeProductList = val.map(item => {
					return {
						productId: item.productId,
						productName: item.productName,
						discountPrice: item.discountPrice
					};
				});
			},
			deleteSelectionChange(val) {
				this.deleteSelection = val;
			},
			getRobot(){
				var params = {}
				getRobotList(this.queryParams).then(res => {
					if (res.code == 200) {
						this.robotList = res.data
					}
				})
			},
			selectRobot(e){
				this.form.robotId = e.robotId
			}
		}
	}
</script>
<style scoped>
	@import url("../../assets/css/product.css");
	.form-container {
		position: relative;
		width: 100%;
		border: 1px solid #E4E6EC;
		padding: 20px 10px;
	}
	/deep/ .el-form-item__content {
		margin-left: 0 !important;
	}
	@media (max-width: 768px) {
		.form-container {
			padding: 15px 10px;
		}
	}
	.search-product-inner {
			/* width: calc(100% - 180px);
			display: grid;
			grid-template-columns: repeat(2, minmax(0px, 1fr));
			gap: 0px 20px; */
		}
		@media (max-width: 767px) {
			.search-btns {
				width: 204px;
			}
		}
	
		@media (max-width: 767px) {
			.search-container {
				flex-wrap: wrap;
				gap: 8px;
			}
	
			.search-block {
				width: 100%;
				min-width: 100px;
			}
	
			.search-btns {
				width: 100%;
				display: flex;
				justify-content: flex-end;
				gap: 8px;
			}
			.search-product-inner {
				width: 100%;
				display: grid;
				grid-template-columns: repeat(2, minmax(0px, 1fr));
				gap: 0px 20px;
			}
	
			.el-cascader {
				width: 100% !important;
				max-width: none;
			}
	
			.el-input {
				width: 100% !important;
			}
		}
	  /* Add this to your <style> section */
	.el-table__row.is-disabled {
	  background-color: #f5f7fa;
	  color: #c0c4cc;
	  pointer-events: none;
	}
	
	.el-table__row.is-disabled .cell {
	  color: #c0c4cc;
	}
	.v-upload-container {
		position: relative;
		width: 100%;
		height: auto;
		overflow: hidden;
	}
	
	.upload-placeholder {
		width: 100%;
		height: 26px;
		line-height: 26px;
		font-size: 13px;
		color: #999;
		text-align: center;
		white-space: nowrap; /* 防止文本换行 */
		overflow: hidden; /* 隐藏溢出的内容 */
		text-overflow: ellipsis;
		display: block;
	}
	
	.v-upload-container .v-upload-area {
		float: left;
		width: 100px;
		height: auto;
		cursor: pointer;
		overflow: hidden;
		margin: 0 8px 8px 0;
	}
	
	.uploaded-img {
		border: 2px solid #eee;
		border-radius: 4px;
		width: 100%;
		height: 100px;
		object-fit: cover;
		border-radius: 4px;
		display: block;
	}
	.v-upload-container .v-upload-area-selected .uploaded-img {
		border: 2px solid #443FF6;
	}
	.v-upload-item {
	    color: #606266;
	    display: block;
	    overflow: hidden;
	    padding-left: 4px;
	    text-overflow: ellipsis;
	    transition: color .3s;
	    white-space: nowrap;
	}
	.v-upload-item [class^=el-icon] {
	    height: 100%;
	    margin-right: 7px;
	    color: #909399;
	    line-height: inherit;
	}
	.card-header {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
</style>